import React, { useState } from 'react';
import { Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import ButtonsContainer from 'shared/lib/components/controls/buttons/buttonsContainer';
import PrimaryButton from 'shared/lib/components/controls/buttons/primaryButton';
import SecondaryButton from 'shared/lib/components/controls/buttons/secondaryButton';
import Modal, { ModalProps } from 'shared/lib/components/modals/modal';
import {
  ExplorerEntityTypes,
  InitialPlacement,
  explorerEntitesItems,
} from 'entities/types';
import { useTranslation } from 'react-i18next';
import CustomSelect from 'shared/lib/components/controls/selects/customSelect';
import PlacementSelection from 'widgets/selectPlacement/placementSelection';

export default observer(function RestoreAllModal({
  initialFolderId,
  initialSectionId,
  onSubmit,
  applyText,
  headerText,
  handleClose,
  isOpen,
  sx,
}: ModalProps &
  InitialPlacement & {
    onSubmit: (params: {
      entityType: ExplorerEntityTypes;
      sectionId?: string;
      folderId?: string;
    }) => Promise<any>;
    applyText?: string;
    headerText?: string;
  }) {
  const { t } = useTranslation();
  applyText = applyText || t('common.restore');
  headerText = headerText || t('actions.groupRestoring');

  const [entityType, setEntityType] = useState<ExplorerEntityTypes>(
    ExplorerEntityTypes.SECTION
  );

  const [isLoading, setIsLoading] = useState(false);

  const [selectedFolderId, setSelectedFolderId] = useState<string>(
    initialFolderId || ''
  );
  const [selectedSectionId, setSelectedSectionId] = useState<string>(
    initialSectionId || ''
  );

  return (
    <Modal isOpen={isOpen} handleClose={handleClose}>
      <Typography variant="f24">{headerText}</Typography>

      <CustomSelect
        value={entityType}
        items={explorerEntitesItems}
        onChange={setEntityType}
        label={t('common.selectEntity')}
        isEmptyItem={false}
      ></CustomSelect>

      {entityType !== ExplorerEntityTypes.SECTION && (
        <PlacementSelection
          initialSectionId={selectedSectionId}
          initialFolderId={selectedFolderId || ''}
          onChangeFolder={(folderId) => setSelectedFolderId(folderId || '')}
          onChangeSection={(sectionId) => setSelectedSectionId(sectionId)}
          labelProps={{
            textFolder: t('common.selectFolder'),
            textSection: t('common.selectSection'),
            typographyVariantSize: 'f16',
          }}
        />
      )}

      <ButtonsContainer>
        <SecondaryButton onClick={handleClose}>
          {t('common.cancel')}
        </SecondaryButton>
        <PrimaryButton
          loading={isLoading}
          onClick={async () => {
            setIsLoading(true);

            try {
              await onSubmit({
                sectionId:
                  entityType === ExplorerEntityTypes.SECTION
                    ? undefined
                    : selectedSectionId,
                folderId:
                  entityType === ExplorerEntityTypes.SECTION
                    ? undefined
                    : selectedFolderId,
                entityType,
              });
            } catch (e) {
              console.error(e);
            }

            setIsLoading(false);
          }}
        >
          {applyText}
        </PrimaryButton>
      </ButtonsContainer>
    </Modal>
  );
});
